import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core"
import { GenericDocumentacion } from "../../../atomic/organisms/GenericDocumentacion"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getAllTiposDocumentacionAfiliadoIntegracion, getDocumentacionAfiliadoIntegracion } from "../../../../actions/discapacidad/discapacidadActions"

export const ModalDocumentacionAfiliado = (props) => {
    const dispatch = useDispatch();
    const { documentacionAfiliado, tiposDocumentacionAbm, solicitudSeleccionada, afiliadoSeleccionado } = useSelector((state) => state.discapacidad);

    useEffect(() => {
        dispatch(getAllTiposDocumentacionAfiliadoIntegracion());
        dispatch(getDocumentacionAfiliadoIntegracion(afiliadoSeleccionado ?
            afiliadoSeleccionado.id_afiliado
            : (solicitudSeleccionada ? solicitudSeleccionada?.afiliado?.id_afiliado : props.afiliadoAut?.id_afiliado)))

    }, [dispatch, props.afiliado?.id_afiliado])
    return (
        <Dialog
            open={props.open}
            onClose={props.handleClose}
            maxWidth={"md"}
        >
            <DialogTitle style={{ cursor: 'move', paddingBottom: 0 }} id="draggable-dialog-title">
                <span style={{ fontWeight: "bold" }}>Generalidades</span>
            </DialogTitle>
            <DialogContent>
                <GenericDocumentacion
                    tiposDocumentacion={tiposDocumentacionAbm.map(item => ({ ...item.tipoDocumentacion }))}
                    documentacion={documentacionAfiliado.map(item => ({ ...item, idDocumentacion: item.idDocumentacionAfiliadoIntegracion }))}
                    fieldsDisabled={true}
                />
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={props.handleClose} color="primary">
                    CERRAR
                </Button>
            </DialogActions>
        </Dialog>
    )
}